import { CommonHttp } from "@/models/interfaces/http/common.http.request";
import { TagBase, TagWithFrequency } from "@/models/interfaces/tags/tag-models";


export class TagsApi {
    // Получение списка тегов для заданной сущности
    static getTagsList(type: number): Promise<any> {
        const http = new CommonHttp()
        return http
            .get(`Tag/GetList?type=${type}`)
            .then(data => data.data)
    }
    // Создание тега для заданной сущности
    static addTag(model: AddToEntityTagModel): Promise<TagBase[]> {
        const http = new CommonHttp()
        return http
            .post(`Tag/add`, model)
            .then(data => data.data)
    }

    static AddTag(model: AddToEntityTagModel): Promise<TagWithFrequency[]> {
        const http = new CommonHttp()
        return http
            .post(`Tag/Add`, model)
            .then(data => data.data)
    }
    // Отсоединение тега от сущности
    static async deleteTag(model: DeleteTagFromEntityModel): Promise<boolean> {
        const http = new CommonHttp()
        const res: any = await http.delete(`Tag/delete`, model)
        return res?.status === 204
    }
}

export type AddToEntityTagModel = {
    EditingTagId: number,
    Name: string,
    EntityType: number,
    EntityId: number,
}

export type DeleteTagFromEntityModel = {
    TagId: number,
    EntityType: number,
    EntityId: number,
}
